const asset = (file) => `${process.env.PUBLIC_URL}/assets/${file}`;

export const LOGO_FULL = asset("matchgate-logo-text.png");
export const LOGO_ICON = asset("matchgate-logo.png");

// Hauptnavigation - identisch in Kopfzeile und Footer-Spalte "Plattform".
export const NAV_LINKS = [
  { label: "Das ist MatchGate", to: "/" },
  { label: "Für Vereine", to: "/fuer-vereine" },
  { label: "Für Unternehmen", to: "/fuer-unternehmen" },
  { label: "Preisstruktur", to: "/preisstruktur" },
  { label: "Demo", to: "/demo" },
];

export const COMPANY_LINKS = [
  { label: "Über uns", to: "/ueber-uns" },
  { label: "Häufige Fragen", to: "/haeufige-fragen" },
  { label: "Warteliste", to: "/warteliste" },
  { label: "Kontakt", to: "/kontakt" },
];

export const LEGAL_LINKS = [
  { label: "Impressum", to: "/impressum" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "AGB", to: "/agb" },
  { label: "Cookies", to: "/cookies" },
];

// Zentrale Anlaufpunkte, damit CTAs nicht quer durch die Seiten gepflegt werden.
export const ROUTE_CONTACT = "/kontakt";
export const ROUTE_DEMO = "/demo";
export const ROUTE_FAQ = "/haeufige-fragen";
// Bis zum Start führen alle Anmelde-Buttons auf die Warteliste. Die alte
// Adresse /registrieren leitet dorthin weiter.
export const ROUTE_WAITLIST = "/warteliste";
// Der Login öffnet mit dem Start, bis dahin ein Hinweis mit Weg zur Warteliste.
export const ROUTE_LOGIN = "/login";
/** Warteliste mit vorgewählter Rolle: "verein" oder "unternehmen". */
export const waitlistFor = (role) => `${ROUTE_WAITLIST}?rolle=${role}`;
// Eigene Adresse fuer MatchGate; Telefon laeuft ueber NxGn Media.
export const CONTACT_EMAIL = "info@matchgate.de";
export const CONTACT_PHONE = "+49 173 2544438";
export const CONTACT_PHONE_HREF = "tel:+491732544438";
